import { motion } from "framer-motion";

/**
 * The rainbow — sign of the Noahide covenant (Genesis 9:13) — rendered as
 * seven concentric hairline arcs that draw themselves on mount.
 */
export const RainbowArcs = ({ className = "", animate = true, strokeWidth = 1 }) => {
  const arcs = [1, 2, 3, 4, 5, 6, 7];
  return (
    <svg
      viewBox="0 0 400 220"
      fill="none"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="xMidYMax meet"
    >
      {arcs.map((n, i) => {
        const r = 60 + i * 20;
        return (
          <motion.path
            key={n}
            d={`M ${200 - r} 210 A ${r} ${r} 0 0 1 ${200 + r} 210`}
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeOpacity={0.9 - i * 0.1}
            strokeLinecap="round"
            initial={animate ? { pathLength: 0, opacity: 0 } : false}
            animate={animate ? { pathLength: 1, opacity: 1 } : false}
            transition={{ duration: 1.6, delay: 0.3 + i * 0.1, ease: [0.22, 1, 0.36, 1] }}
          />
        );
      })}
    </svg>
  );
};
